import { Box } from '@mui/material';
import { styled, keyframes } from '@mui/material/styles';

const dotBefore = keyframes`
  0% {
      box-shadow: 9984px 0 0 -5px;
    }
    30% {
      box-shadow: 9984px 0 0 2px;
    }
    60%, 100% {
      box-shadow: 9984px 0 0 -5px;
    }
  `;

const dot = keyframes`
  0% {
      box-shadow: 9999px 0 0 -5px;
    }
    30% {
      box-shadow: 9999px 0 0 2px;
    }
    60%, 100% {
      box-shadow: 9999px 0 0 -5px;
    }
  `;
const dotAfter = keyframes`
  0% {
      box-shadow: 10014px 0 0 -5px;
    }
    30% {
      box-shadow: 10014px 0 0 2px;
    }
    60%, 100% {
      box-shadow: 10014px 0 0 -5px;
    }
  `;

const StyledBox = styled(Box)(({ theme }) => ({
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  marginTop: theme.spacing(3),
  marginBottom: theme.spacing(3),
  '& .LLDots': {
    position: 'relative',
    left: '-9999px',
    width: theme.spacing(1),
    height: theme.spacing(1),
    borderRadius: '50%',
    backgroundColor: theme.palette.grey[500],
    color: theme.palette.grey[500],
    boxShadow: '9999px 0 0 -5px',
    animation: `${dot} 1.5s infinite linear`,
    animationDelay: '0.25s',
    '&:before, &:after ': {
      content: "''",
      display: ' inline-block',
      position: 'absolute',
      top: 0,
      width: theme.spacing(1),
      height: theme.spacing(1),
      borderRadius: '50%',
      backgroundColor: theme.palette.grey[100],
      color: theme.palette.grey[100],
    },
    '&:before': {
      boxShadow: ' 9984px 0 0 -5px',
      animation: `${dotBefore} 1.5s infinite linear`,
      animationDelay: '0s',
    },
    '&:after': {
      boxShadow: '10014px 0 0 -5px',
      animation: `${dotAfter} 1.5s infinite linear`,
      animationDelay: '0.5s',
    },
  },
}));

export default StyledBox;